import { Modal } from "@crowd/ui-kit";
import { ComponentProps, FC, Fragment } from "react";
import cn from "classnames";
import { useIsMobile } from "../../../../hooks/useMedia";
import AppModalPhoneHeader from "./AppModalPhoneHeader/AppModalPhoneHeader";
import styles from "./AppModal.module.scss";
import AppModalCloseIcon from "./AppModalCloseIcon/AppModalCloseIcon";

export interface AppModalProps extends ComponentProps<typeof Modal> {
  showPhoneHeader?: boolean;
  showPhoneHeaderProfile?: boolean;
}

const AppModal: FC<AppModalProps> = ({
  showPhoneHeader = true,
  showPhoneHeaderProfile = true,
  children,
  CloseIconComponent,
  classNames,
  ...otherProps
}) => {
  const isPhone = useIsMobile();

  const onClose = (e) => {
    e?.stopPropagation();
    otherProps.onClose();
  };

  const renderContent = () => {
    if (!isPhone || !showPhoneHeader) {
      return children;
    }

    const childrenArr = [...(Array.isArray(children) ? children : [children])];
    const headerIndex = childrenArr.findIndex((c) => c.key === "header");

    const headerElement = (
      <Fragment key="header">
        <div className={styles["phone-header-wrapper"]}>
          <AppModalPhoneHeader
            onLogoClick={onClose}
            showProfile={showPhoneHeaderProfile}
          />
          {!!~headerIndex && (
            <div>{childrenArr[headerIndex].props?.children}</div>
          )}
        </div>
      </Fragment>
    );

    if (~headerIndex) {
      childrenArr[headerIndex] = headerElement;
    } else {
      childrenArr.unshift(headerElement);
    }

    return childrenArr;
  };

  return (
    <Modal
      classNames={cn(styles.modal, classNames)}
      CloseIconComponent={CloseIconComponent || AppModalCloseIcon}
      {...otherProps}
    >
      {renderContent()}
    </Modal>
  );
};

export default AppModal;
